import React from "react";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import type { Dispatch } from "redux";
import { connect } from "react-redux";
import { getBackend as getBackend2 } from "@/lib/backend/backend2";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import { REPORT_LOADING_ACTION_NAME } from "@/modules/pg/shared/planningTable/reducers/report";
import { SAVE_TO_SAP_PARALLEL_REPORT_LOADING } from "@/modules/pg/shared/planningTable/reducers/report/parallelReport";

import type { ReportLoadingAction } from "@/modules/pg/shared/planningTable/reducers/report";
import type { SaveToSapParallelReportLoading } from "@/modules/pg/shared/planningTable/reducers/report/parallelReport";

type ActionTypes = ReportLoadingAction | SaveToSapParallelReportLoading;

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class AbortButton extends React.Component<Props> {
    onCancel = () => {
        const backend = getBackend2();
        const api_client = backend.getApiClient();
        api_client.abort();
        if (this.props.is_report_loading) {
            this.props.reduxDispatch({ type: REPORT_LOADING_ACTION_NAME, data: false });
        }

        if (this.props.is_parallel_report_loading) {
            this.props.reduxDispatch({ type: SAVE_TO_SAP_PARALLEL_REPORT_LOADING, data: false });
        }
    };

    render() {
        const is_disabled = this.props.report_uuid === null;
        const is_loading = this.props.is_report_loading || this.props.is_parallel_report_loading;
        if (is_loading) {
            return (
                <button disabled={is_disabled} className="abort-button btn btn-primary" onClick={this.onCancel}>
                    <i className="fas fa-spinner fa-spin"></i>
                    <span style={{ marginLeft: "5px" }}>{translate("common.cancel", "Cancel")}</span>
                </button>
            );
        }
        return null;
    }
}

const mapState = (state: ReduxState) => {
    const report = state.gantt_chart_report;
    const parallel_report = state.gantt_chart_parallel_report;
    const report_uuid = report.original_report_uuid;
    return {
        is_report_loading: report.report_loading,
        is_parallel_report_loading: parallel_report.save_to_sap_parallel_loading,
        report_uuid,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(AbortButton);
